export default "__VITE_ASSET__UhgLrG2h__"